import { object, func } from 'prop-types'

import scope from 'recompose-scope/composeWithScope'
import consumeProps from 'recompose-scope/consumeProps'
import exposeProps from 'recompose-scope/exposeProps'

import interceptUpdater from 'coact-utils/interceptUpdater'

import HeadEditorView from './HeadEditor'


const HeadEditor = scope(
  consumeProps({
    value: object,
    onChange: func.isRequired,
  }),

  interceptUpdater('onChange', () => (value, oldValue) => {
    const {
      brandRef: brandRefOrigin,
      model: modelOrigin,
      colorCode: colorCodeOrigin,
      material: materialOrigin,
      rimType: rimTypeOrigin,
      colorRef: colorRefOrigin,
      contour: contourOrigin,
    } = value
    const {
      brandRef: oldBrandRefOrigin,
      model: oldModelOrigin,
      colorCode: oldColorCodeOrigin,
      material: oldMaterialOrigin,
      rimType: oldRimTypeOrigin,
      colorRef: oldColorRefOrigin,
      contour: oldContourOrigin,
    } = oldValue

    const brandRef = brandRefOrigin || { }
    const model = modelOrigin || ''
    const colorCode = colorCodeOrigin || ''
    // const material = ((materialOrigin || '').split('-')[1]) ?
    // ((materialOrigin || '').split('-')[1]) : ((materialOrigin || '').split('-')[0])
    const material = (materialOrigin || '').split('-')[1]
    const rimType = (rimTypeOrigin || '').split('-')[1]
    const colorRef = colorRefOrigin || { }
    const contour = (contourOrigin || '').split('-')[1]

    const brandRefRelated = (brandRefOrigin !== oldBrandRefOrigin) ? {
      brandCode: brandRef && brandRef.key.split('-')[0],
      key: brandRef && [brandRef.key.split('-')[0], model, colorCode].join('-'),
      name: brandRef && [
        brandRef.key.slice(brandRef.key.indexOf('-') + 1, brandRef.key.length),
        model,
        material,
        rimType,
        colorRef.key,
        contour,
      ].join('-'),
    } : { }

    const modelRelated = (modelOrigin !== oldModelOrigin) ? {
      key: [brandRef.key.split('-')[0], model, colorCode].join('-'),
      name: [
        brandRef.key.slice(brandRef.key.indexOf('-') + 1, brandRef.key.length),
        model,
        material,
        rimType,
        colorRef.key,
        contour,
      ].join('-'),
    } : { }

    const colorCodeRelated = (colorCodeOrigin !== oldColorCodeOrigin) ? {
      key: [brandRef.brandCode, model, colorCode].join('-'),
    } : { }

    const materialRelated = (materialOrigin !== oldMaterialOrigin) ? {
      name: [
        brandRef.key.slice(brandRef.key.indexOf('-') + 1, brandRef.key.length),
        model,
        material,
        rimType,
        colorRef.key,
        contour,
      ].join('-'),
    } : { }

    const rimTypeRelated = (rimTypeOrigin !== oldRimTypeOrigin) ? {
      name: [
        brandRef.key.slice(brandRef.key.indexOf('-') + 1, brandRef.key.length),
        model,
        material,
        rimType,
        colorRef.key,
        contour,
      ].join('-'),
    } : { }

    const colorRefRelated = (colorRefOrigin !== oldColorRefOrigin) ? {
      name: colorRef && [
        brandRef.key.slice(brandRef.key.indexOf('-') + 1, brandRef.key.length),
        model,
        material,
        rimType,
        colorRef.key,
        contour,
      ].join('-'),
    } : { }

    const contourRelated = (contourOrigin !== oldContourOrigin) ? {
      name: [
        brandRef.key.slice(brandRef.key.indexOf('-') + 1, brandRef.key.length),
        model,
        material,
        rimType,
        colorRef.key,
        contour,
      ].join('-'),
    } : { }

    return {
      ...value,
      ...brandRefRelated,
      ...modelRelated,
      ...colorCodeRelated,
      ...materialRelated,
      ...rimTypeRelated,
      ...colorRefRelated,
      ...contourRelated,
    }
  }),

  exposeProps([
    'value',
    'onChange',
  ]),
)(HeadEditorView)

HeadEditor.displayName = 'HeadEditor'

export default HeadEditor



// WEBPACK FOOTER //
// ./src/components/products/productsA/HeadEditor/index.js